const USER_NOT_FOUND = "User does not exist.";
const EMAIL_ALREADY_EXIST = "User already exists.";
const INVALID_CREDENTIAL = "Incorrect username or password.";
const INVALID_PASSWORD_FORMATE = "Password should be at least 6 characters";
export {
  USER_NOT_FOUND,
  EMAIL_ALREADY_EXIST,
  INVALID_CREDENTIAL,
  INVALID_PASSWORD_FORMATE,
};
